import { ReprographyResponseInterface } from '../interfaces/reprography-response.interface';

export class ReprographyModel implements ReprographyResponseInterface {
  /**
   * emai of user
   */
  mail: string;

  /**
   * Creates an instance of DsDocumentsExportResponse.
   *
   * @param jsonObject the json data
   */
  constructor(jsonObject: ReprographyResponseInterface) {
    this.mail = jsonObject.mail;
  }
}
